// data/applicantsWithoutATS.ts
import { useEffect, useState, useCallback } from "react";
import { collection, query, where, orderBy, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../providers/database";
import { collectionNames } from "./dictionary/collectionNames";
import { useQuery } from "react-query";

export const usePaginatedApplicantsWithoutATS = (jobId: string) => {
  const [applicants, setApplicants] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchApplicants = useCallback(async () => {
    if (!jobId) return;
    setLoading(true);

    try {
      const baseRef = collection(db, "Applicants_without_ATS");

      const q = query(
        baseRef,
        where("jobId", "==", jobId),
        orderBy("applyDate", "desc"),
      );

      const snapshot = await getDocs(q);

      const docs = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setApplicants(docs);
    } catch (err) {
      console.error("Error fetching applicants:", err);
    } finally {
      setLoading(false);
    }
  }, [jobId]);

  const resetAndFetch = useCallback(() => {
    setApplicants([]);
    fetchApplicants();
  }, [fetchApplicants]);

  return {
    applicants,
    fetchMore: fetchApplicants,
    resetAndFetch,
    hasMore: false,
    loading,
  };
};

export const useApplicantsWithATS = (jobId: string) => {

  return useQuery(
    ['jobApplicants', jobId],
    async () => {
      if (!jobId) {
        throw new Error("Job ID is required to fetch applicants.");
      }

      const q = query(
        collection(db, collectionNames.JobMetrics),
        where("jobId", "==", jobId),
         where("type", "==", "Apply")

      );

      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        return []; // Return empty array instead of throwing error
      }

      const applicants = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      return applicants;
    },
    {
      enabled: !!jobId,
    }
  );
};


